import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import billProcessReportDetailPropTypes from '../proptypes/BillReportDetailPropTypes';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_FORMAT } from '../../../../../config/locale';
import EnumStatus from '../../../../common/EnumStatus';
import { BILLING_REPORT_DETAIL_STATUS } from '../../../../../config/constants';

const BillProcessReportDetailResource = ({
  id,
  fromDate,
  toDate,
  status,
  s3Url,
  errorMessage,
  createDate,
  lastUpdate,
}) => (
  <>
    <ResourceProperty label="ID:">{id}</ResourceProperty>
    <ResourceProperty label="Fecha Desde:">
      {tzNormalizeDate({ date: fromDate, format: DATE_FORMAT })}
    </ResourceProperty>
    <ResourceProperty label="Fecha Hasta:">
      {tzNormalizeDate({ date: toDate, format: DATE_FORMAT })}
    </ResourceProperty>

    <ResourceProperty label="Estado:">
      <EnumStatus
        enumObject={BILLING_REPORT_DETAIL_STATUS}
        enumValue={status}
      />
    </ResourceProperty>

    <ResourceProperty label="Enlace del Documento:">
      <a href={s3Url} target="_blank" rel="noopener noreferrer">
        {s3Url}
      </a>
    </ResourceProperty>

    <ResourceProperty label="Mensaje de Error:">
      {errorMessage || '—'}
    </ResourceProperty>

    <ResourceProperty label="Creado:">
      {new Date(createDate).toLocaleString()}
    </ResourceProperty>

    <ResourceProperty label="Última Actualización:">
      {new Date(lastUpdate).toLocaleString()}
    </ResourceProperty>
  </>
);

BillProcessReportDetailResource.propTypes = billProcessReportDetailPropTypes;

export default BillProcessReportDetailResource;
